import React, { Component } from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as pagesActions from "../../actions/pages";
import AuthService from '../../lib/AuthService';
import * as userActions from "../../actions/user";

class ForgotPassword extends Component {
    constructor(props){
        super(props);
        this.state = {
            username: '',
            password: '',
            redirect: false,
            loginError : false,
            emailErrormsg : '',
            resetEmail : '',
            newpassword: ''

        };
        this.Auth = new AuthService();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.savenewPassword = this.savenewPassword.bind(this);
    }

    componentDidMount() {
        fetch("config.json")
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.props.saveConfig(data);
            });
        var url = window.location.pathname.split('/');
        this.setState({
            resetUserid: url[2]
        });

    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentWillMount() {

        if (this.Auth.loggedIn()) {
            this.props.history.replace('/vignets');
        }


    }
    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.loggedinData.loggedin !== prevProps.loggedinData.loggedin  && this.props.loggedinData.loggedin === true) {
            this.props.history.replace('/vignets');
        }
        if (this.props.loggedinData.login_error !== prevProps.loggedinData.login_error  && this.props.loggedinData.login_error === true) {

            this.setState({ loginError :true });
        }
        if (this.props.userData.pswdUpdated !== prevProps.userData.pswdUpdated ) {

            this.props.history.push('/');
        }
    }

    resetPassword() {

        let formInvalid = 0;
        let email=/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        var userEmailData =  {
            user_email: this.state.email,
            user_id:  ""
        };
        this.props.checkExistingEmail(userEmailData);

        if (this.state.email === ""){
            formInvalid++;
            document.getElementsByName('email')[0].classList.add('is-invalid');
            this.setState({
                emailErrormsg: 'User Email is required'
            });
        }
        else
        {
            if(!email.test(this.state.email))
            {
                formInvalid++;
                document.getElementsByName('email')[0].classList.add('is-invalid');
                this.setState({
                    emailErrormsg: 'Email is not valid'
                });
            }

        }


        if( formInvalid === 0) {
            var userData = {
                emailid: this.state.email
            };
            let pswdReseted= this.props.reset(userData);
        }
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        console.log(this.state.email);
    }


    savenewPassword(){
        var oLdUserData = this.props.userData.searchEmail;
        console.log(oLdUserData);
        var url = window.location.pathname.split('/');
        var resetUserid = atob(url[2]);

console.log(resetUserid);
        var newuserData = {
            userid : resetUserid,
            password: this.state.newpassword
        };

        let saveNewpassword = this.props.passwordUpdate(newuserData);
    }

    render() {

        let logo = require("../../assets/images/logo-black.png");
        console.log(this.props.userData.searchEmail);
        console.log(this.state.emailErrormsg);
        console.log(this.state.resetUserid);
        console.log(this.props.userData.searchEmail);
        return (
            <div class="wrapper">
                <section class="login-section">
                    <div class="container">
                        <div class="main-holder">
                            <div class="login-panel">
                                <a href="./" class="logo-in">
                                    <span class="logo-image-in"></span>
                                </a>
                                <h1 class="main-head"></h1>

                                {this.state.resetUserid ?
                                    <React.Fragment>
                                    <div className="form-input-all-holder">
                                        <div className="form-input-holder">
                                            <span className="icon-in icon-key"></span>
                                            <input type="password" name="newpassword" className="form-input"
                                                   placeholder="New Password" value={this.state.newpassword}
                                                   onChange={this.handleInputChange} required/>
                                            <a href="javascript:void(0);" className="icon-in icon-eye"></a>
                                        </div>
                                    </div>
                                        <div className={'loginError'}>
                                            <h6>{this.state.pswdErrormsg}</h6>
                                        </div>
                                        <div className="form-input-all-holder">
                                            <input type="submit" onClick={this.savenewPassword} value="Submit"
                                                   className="form-submit"/>
                                        </div>
                                        </React.Fragment>
                                 :
                                    <React.Fragment>
                                    <div className="form-input-all-holder">
                                        <div className="form-input-holder">
                                            <span className="icon-in icon-mail"></span>
                                            <input type="text" name="email" className="form-input" placeholder="Email"
                                                   value={this.state.email} onChange={this.handleInputChange} required/>
                                        </div>
                                    </div>


                                    <div className={'loginError'}>
                                        <h6>{this.state.emailErrormsg!=='' ? this.state.emailErrormsg : this.props.userData.searchEmail === 'valid' ? 'Email Does not exist' : '' }</h6>
                                    </div>
                                      <div class="form-input-all-holder">
                                        <input type="submit" onClick={this.resetPassword} value="Reset Password" class="form-submit" />
                                    </div>
                                        </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}
function mapStateToProps(state) {
    return {
        loggedinData  :state.pages.userSettings,
        userData  :state.user.userListData,
        pageSettingsData  :state.pages.pageSettings
    };

}

export default  withRouter(connect(mapStateToProps, {
    createUser : userActions.createUser,
    passwordUpdate : userActions.passwordUpdate,
    reset : pagesActions.resetPassword,
    saveConfig : pagesActions.saveConfig,
    checkExistingUser :userActions.checkExistingUser,
    checkExistingEmail :userActions.checkExistingEmail,
})(ForgotPassword));


// WEBPACK FOOTER //
// ./src/components/login/ForgotPassword.js